export const printableNumber = (n: number): string => {
  if (n >= 0) {
    return ` +${n}`;
  }

  return ` ${n}`;
};

export const prorbabilityToPercentage = (n: number): number => {
  // Stretch probability away from 50% for readability.
  // Factor 2.45: maps 70% real winrate → 99% display, capped at [1%, 99%].
  const STRETCH = 2.45;
  const stretched = 0.5 + (n - 0.5) * STRETCH;
  const clamped = Math.min(0.99, Math.max(0.01, stretched));
  return Math.round(clamped * 1000) / 10;
};
